export default "__VITE_ASSET__CM422FwO__"